"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cacheUtil = void 0;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class cacheUtil {
  static setItem(key, object) {
    let persistData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (persistData === false) {
      sessionStorage.setItem(key, object ? JSON.stringify(object) : null);
    } else {
      localStorage.setItem(key, object ? JSON.stringify(object) : null);
    }
  }
  static getItem(key) {
    /* Check local Storage; if null; check session storage */
    let data = localStorage.getItem(key);
    if (data === null) {
      data = sessionStorage.getItem(key);
      return data === null ? null : JSON.parse(data);
    }
    return JSON.parse(data);
  }
  static removeItem(key) {
    /* Remove from both localstorage and session storage */
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }
}
exports.cacheUtil = cacheUtil;
_defineProperty(cacheUtil, "logLevel", "DEBUG");
;